export const BASE_URL = "https://sandbox-backend.kaaruj.cloud/";
